<div
  *ngIf="!!items?.length"
  class="scroll-container"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="100"
  [scrollWindow]="false"
  [infiniteScrollDisabled]="!hasMoreData"
  (scrolled)="triggerLoadMore()"
>
  <ng-content></ng-content>

  <div *ngIf="loading">⏳ Loading...</div>

  <!-- <div *ngIf="!hasMoreData">✅ All items loaded!</div> -->
</div>
